import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { Injectable } from '@angular/core';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { DatePipe } from '@angular/common';
import { TranslateResourceDefinitionPipe } from 'src/app/shared/pipes/translateResourceDefinition.pipe';
import { AuthentService } from 'src/app/Services/authent.service';

var language= {
  value: "",
}

var MY_FORMATS = {
  parse: {
    dateInput: '',
  },
  display: {
    dateInput: "",
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-day-datepicker-format',
  templateUrl: './day-datepicker-format.component.html',
  styleUrls: ['./day-datepicker-format.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})

@Injectable({
  providedIn: 'root'
})

export class DayDatepickerFormatComponent implements OnInit {
  @Input() properties;
  @Input() format : string;
  @Input() groupName: string;
  @Output() dateValue  = new EventEmitter();
  @Output() clickEvent = new EventEmitter();

  resourceDefinition;

  constructor(
    private shareData: SharingDataService,
    public datePipe: DatePipe,
    public translateResourceDefinition: TranslateResourceDefinitionPipe,
    public dateAdapter: DateAdapter<any>,
    private authentService: AuthentService
  ) { }

  ngOnInit(): void {
    this.shareData.currentResourceDefinition.subscribe(data => this.resourceDefinition = data);
    this.shareData.currentLanguage.subscribe(data => {
      if(this.authentService.isLoggedIn()) this.dateAdapter.setLocale(data);
    });
    MY_FORMATS.display.dateInput = MY_FORMATS.parse.dateInput = this.format.toUpperCase();
  }

  dateChange(value){
    let date = new Date(value.value);
    var dateValue = this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ssZ").substring(0,22) + ":" + this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ssZ").substring(22);
    let object = {
      value: dateValue,
      type: value.targetElement.name,
    }
    this.dateValue.emit(object)
  }

  click(event){
    this.clickEvent.emit(event);
  }
}
